import { render, staticRenderFns } from "./HeaderDenunciaGral.vue?vue&type=template&id=da2ab6f4&scoped=true"
import script from "./HeaderDenunciaGral.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDenunciaGral.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDenunciaGral.vue?vue&type=style&index=0&id=da2ab6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2ab6f4",
  null
  
)

export default component.exports